import { SupportTicket } from '@zenstackhq/runtime/models'
import { message } from 'antd'
import { Api } from '~/core/trpc'
import { OrganizationType } from '~/features/organization/common'

export type DataFilters = {
  status: ('OPEN' | 'CLOSED')[]
}

type Props = {
  organization: OrganizationType
}

export const useLogic = ({ organization }: Props) => {
  const updateMutation = Api.supportTicket.update.useMutation()

  const update = async (values: Partial<SupportTicket>) => {
    try {
      await updateMutation.mutateAsync({
        where: {
          id: values.id,
        },
        data: {
          ...values,
        },
      })
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  return {
    update,
  }
}
